export default "__VITE_PUBLIC_ASSET__a2e500aa__"